'use strict';

/**
 * Displays the best tariff plan we can offer you, based on your usage patterns.
 * For the widget that links to bestetarief.be (BIPT), check bestTariff.
 */
customerZone.component('ourBestTariff', {
    templateUrl:
        customerZone.fromBase('components/our-best-tariff/our-best-tariff.component.html'),
    controllerAs: 'vm',
    controller: ['$log', 'Session', 'BudskapClient', 'ProductService', 'config',
        'utils', '$q', function($log, Session, budskapClient, ProductService, config, utils, $q){

            var self = this;

            self.subscriber = Session.subscriber();
            self.subscribers = Session.subscribers()
                .filter(function(s) {
                    return s.state === 'enabled' && s.isPostpaid();
                });
            self.loading = false;
            self.noBetterTariff = null;
            self.bestTariff = null;
            self.bestProduct = null;
            self.noPostpaidSubscription = null;

            var init = function (){
                window.dataLayer.push({
                    event: 'best_tariff_page_load',
                });

                if (self.subscribers.length === 0) {
                    self.noPostpaidSubscription = true;
                }
                self.subscriber = self.subscribers[0];
                if (self.subscribers.length === 1) {
                    // No SIM selector if there is only 1 subscription, kickstart on page load
                    self.getResults();
                }
            };

            self.getResults = function() {
                self.loading = utils.translate('loading_your_best_tariff');
                self.bestTariff = null;
                self.bestProduct = null;
                self.noBetterTariff = null;
                $q.all([
                    budskapClient.getBestTariffs(self.subscriber.subscription.id),
                    ProductService.getSubscriptionProducts('postpaid', 'include legacy')
                ]).then(function(results) {
                    var bestTariff = results[0];
                    var postpaidProducts = results[1];

                    self.loading = false;

                    self.bestTariff = bestTariff;
                    if (!bestTariff || bestTariff.suggestionType === 'no_change'
                        || bestTariff.suggestedProductId === self.subscriber.subscription.product.id) {
                        self.noBetterTariff = true;
                        return;
                    }

                    var product = bestMatchingProduct(postpaidProducts, bestTariff.suggestedProductId);
                    self.bestProduct = product;

                }).catch(function(error){
                    $log.error('Failed to load best tariff', error);
                    utils.showError();
                    self.loading = false;
                }).then(function() {
                    if (self.bestTariff) {
                        window.dataLayer.push({
                            event: 'best_tariff_check_done',
                            'best_tariff_identity_id': self.subscriber.subscription.id,
                            'best_tariff_current_priceplan_id': self.bestTariff.currentProductId,
                            'best_tariff_suggested_priceplan_id': self.bestTariff.suggestedProductId,
                            'best_tariff_suggested_direction': self.bestTariff.suggestionType
                        });
                    }
                });
            };

            Object.defineProperty(self, 'notLoggedIn', {
                get: function () {
                    return !Session.authenticated();
                },
            });

            Object.defineProperty(self, 'currentPlan', {
                get: function () {
                    if (!self.subscriber) return null;
                    return self.subscriber.product;
                },
            });

            Object.defineProperty(self, 'migrationUrl', {
                get: function () {
                    if (!self.bestProduct) return null;
                    return config.eserviceUrl+'#!/migration?product='+self.bestProduct.id;
                }
            });

            Object.defineProperty(self, 'why', {
                get: function () {
                    if (!self.bestProduct) return '';
                    if (self.bestProduct.price > self.currentPlan.price)
                        return utils.translate('best_tariff__why_upgrade');
                    if (self.bestProduct.price < self.currentPlan.price) {
                        return utils.translate('best_tariff__why_downgrade');
                    }
                    if (!self.subscriber.product.available)
                        if (self.subscriber.product.price === 10.0)
                            return utils.translate('best_tariff__why_migrate_legacy_to_binge_10');
                        else if (self.subscriber.product.price === 15.0)
                            return utils.translate('best_tariff__why_migrate_legacy_to_binge_15');
                        else if (self.subscriber.product.price === 20.0)
                            return utils.translate('best_tariff__why_migrate_legacy_to_binge_20');
                    return utils.translate('best_tariff__why_migrate_binge_to_binge');
                }
            });
            Object.defineProperty(self, 'whyShort', {
                get: function () {
                    if (!self.bestProduct) return '';

                    if (self.bestProduct.price > self.currentPlan.price)
                        return utils.translate('best_tariff__why_upgrade_short');
                    if (self.bestProduct.price < self.currentPlan.price) {
                        return utils.translate('best_tariff__why_downgrade_short');
                    }
                    if (!self.subscriber.product.available)
                        return utils.translate('best_tariff__why_migrate_legacy_to_binge_short');
                    return utils.translate('best_tariff__why_migrate_binge_to_binge_short');
                }
            });

            var bestMatchingProduct = function(products, suggestedProductId) {
                var product = products.find(function(p) { return p.id === suggestedProductId; });
                if (!product) {
                    throw new Error('Best tariff product recommendation not found, product id: '
                        + self.suggestedProductId);
                }
                return product;
            };

            init();
        }]
});
